export const DEEP_LINK_REWARD_PACKAGES = 'rewardPackages';
export const DEEP_LINK_LOCATION_IN_GAME = 'locationInGame';
export const DEEP_LINK_SUB_LOCATION = 'subLocation';
export const DEEP_LINK_END_DATE = 'dueDate';
export const DEEP_LINK_PLATFORM_TOKENS = 'platformTokens';
export const DEEP_LINK_PLATFORM = 'platformId';

export const DEEP_LINK_MULTI_REDEMPTIONS = 'multipleRedemptions';

export const DEEP_LINK_MAX_REDEMPTIONS = 'maxRedemptions';

export const DEEP_LINK_SUB_LOCATION_SHOP = 1016;
export const DEEP_LINK_AUDIENCES = 'linkedAudienceIds';
export const DEEP_LINK_TARGET_USERS = 'targetUsers';

export const DEEP_LINK_TARGET_USERS_ALL_USERS = 3;
export const DEEP_LINK_TARGET_USERS_AUDIENCE = 4;
